import React from 'react';
import StaticPage, { Section, CardGrid } from './StaticPage';

export default function StudentGuide() {
  return (
    <StaticPage title="Student Accommodation Guide" subtitle="Everything you need to know about finding housing in Australia as a student.">
      <Section title="Getting Started">
        <p>Finding accommodation in Australia can feel overwhelming, especially if you're arriving from overseas. This guide walks you through every step — from understanding room types to signing a lease and knowing your rights as a tenant.</p>
      </Section>

      <Section title="Types of Accommodation">
        <CardGrid items={[
          { title: 'Student Purpose-Built (PBSA)', desc: 'Managed buildings designed for students — include furnished rooms, utilities, WiFi, and communal spaces like gyms and study hubs.' },
          { title: 'Shared House / Flatshare', desc: 'Rent a room in a house shared with other students or young professionals. Usually cheaper but requires more coordination.' },
          { title: 'Studio Apartments', desc: 'Self-contained apartments with your own kitchen and bathroom. More expensive but more privacy.' },
          { title: 'Homestay', desc: 'Live with a local Australian family. Great for improving English and cultural immersion.' },
          { title: 'On-Campus Colleges', desc: 'University-managed residential colleges, often with meal plans. Apply early as they fill up fast.' },
          { title: 'Short-Term Rentals', desc: 'Airbnb or serviced apartments for the first few weeks while you search for longer-term housing.' },
        ]} />
      </Section>

      <Section title="Before You Sign a Lease">
        <ul className="list-disc list-inside space-y-2">
          <li>Always inspect the property in person or via video call before paying anything</li>
          <li>Never transfer money before signing a lease</li>
          <li>Check that the landlord is verified on RentalX</li>
          <li>Read the lease carefully — check the bond amount, rent, and notice periods</li>
          <li>Understand your rights under your state's Residential Tenancies Act</li>
          <li>Get contents insurance to protect your belongings</li>
        </ul>
      </Section>

      <Section title="Average Weekly Rents (2026)">
        <CardGrid items={[
          { title: 'Melbourne', desc: 'Private room: A$250–400/wk · Studio: A$350–550/wk · PBSA: A$350–600/wk' },
          { title: 'Sydney', desc: 'Private room: A$280–450/wk · Studio: A$400–650/wk · PBSA: A$380–650/wk' },
          { title: 'Brisbane', desc: 'Private room: A$220–360/wk · Studio: A$300–480/wk · PBSA: A$300–500/wk' },
          { title: 'Perth', desc: 'Private room: A$200–340/wk · Studio: A$280–440/wk · PBSA: A$280–480/wk' },
        ]} />
      </Section>

      <Section title="Useful Resources">
        <ul className="list-disc list-inside space-y-2">
          <li>Tenants Victoria: <strong>tuv.org.au</strong></li>
          <li>NSW Fair Trading: <strong>fairtrading.nsw.gov.au</strong></li>
          <li>Queensland Residential Tenancies Authority: <strong>rta.qld.gov.au</strong></li>
          <li>Australian Government Housing Help: <strong>housinghelp.gov.au</strong></li>
        </ul>
      </Section>
    </StaticPage>
  );
}
